/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Set_IncodeInputs */

const en_shortcut_keys_name_set_incode = /** @type {(inputs: Shortcut_Keys_Name_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Incode (Start)`)
};

const fr_shortcut_keys_name_set_incode = /** @type {(inputs: Shortcut_Keys_Name_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir l'incode (debut)`)
};

const de_shortcut_keys_name_set_incode = /** @type {(inputs: Shortcut_Keys_Name_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Incode (Start)`)
};

const it_shortcut_keys_name_set_incode = /** @type {(inputs: Shortcut_Keys_Name_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta Incode (Avvia)`)
};

const ru_shortcut_keys_name_set_incode = /** @type {(inputs: Shortcut_Keys_Name_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Установить код ввода (Начало)`)
};

const es_shortcut_keys_name_set_incode = /** @type {(inputs: Shortcut_Keys_Name_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Establecer Incode (Inicio)`)
};

const zh_cn2_shortcut_keys_name_set_incode = /** @type {(inputs: Shortcut_Keys_Name_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置 Incode（开始）`)
};

const ja_shortcut_keys_name_set_incode = /** @type {(inputs: Shortcut_Keys_Name_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インコードの設定（開始）`)
};

const hi_shortcut_keys_name_set_incode = /** @type {(inputs: Shortcut_Keys_Name_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इनकोड सेट करें (प्रारंभ)`)
};

const pt_pt2_shortcut_keys_name_set_incode = /** @type {(inputs: Shortcut_Keys_Name_Set_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir código de entrada (Início)`)
};

/**
* | output |
* | --- |
* | "Set Incode (Start)" |
*
* @param {Shortcut_Keys_Name_Set_IncodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_set_incode = /** @type {((inputs?: Shortcut_Keys_Name_Set_IncodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Set_IncodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_set_incode(inputs)
	if (locale === "de") return de_shortcut_keys_name_set_incode(inputs)
	if (locale === "it") return it_shortcut_keys_name_set_incode(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_set_incode(inputs)
	if (locale === "es") return es_shortcut_keys_name_set_incode(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_set_incode(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_set_incode(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_set_incode(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_set_incode(inputs)
	return en_shortcut_keys_name_set_incode(inputs)
});